<template>
  <v-app>
    <Keyboard />
    <Messages />
    <div style="height: 100%" class="d-flex flex-column align-center justify-center">
      <Login />
    </div>
  </v-app>
</template>

<script>
import Keyboard from '../components/keyboard'
import Messages from '../components/messages'
import Login from '../components/login'

export default {
  components:{
    Messages,
    Login,
    Keyboard
  }
}
</script>